import { Base } from '../base-component';
import './follow-media-icons.component.scss';

export class FollowMediaIcons extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/follow-media-icons/follow-media-icons.component.ts